export default [
  { _id: 1, name: "Inside the office" },
  { _id: 2, name: "Outside the office" },
];
